import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';

const Privacy = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <div className="pt-20 bg-white">
      <section className="py-20 px-6 lg:px-12 bg-[#ff5200] text-white">
        <div className="max-w-5xl mx-auto text-center">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-5xl md:text-7xl font-bold"
          >
            {t.footer.privacy}
          </motion.h1>
        </div>
      </section>

      <section className="py-20 px-6 lg:px-12">
        <div className="max-w-4xl mx-auto prose prose-lg">
          {language === 'de' ? (
            <div className="space-y-8">
              <p className="text-sm text-gray-600">Letzte Aktualisierung: November 2025</p>
              
              <div>
                <h2 className="text-3xl font-bold mb-4">Datenschutzerklärung</h2>
                <h3 className="text-2xl font-bold mb-3">1. Verantwortliche Stelle</h3>
                <p>
                  Lussho GmbH<br />
                  handelnd unter der Marke PIK Agency<br />
                  Sachsenhäuser Landwehrweg 159A<br />
                  60599 Frankfurt am Main, Deutschland<br />
                  E-Mail: hello@pikagency.de<br />
                  Telefon: +49 172 3068227
                </p>
                <p className="mt-4">
                  Vertretungsberechtigte Geschäftsführerinnen:<br />
                  Esma Kaya Gürsoy, Yagmur Yüksel
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">2. Allgemeine Hinweise zur Datenverarbeitung</h3>
                <p>
                  Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Personenbezogene Daten werden gemäß der Datenschutz-Grundverordnung (DSGVO) und den geltenden Datenschutzgesetzen vertraulich behandelt.
                </p>
                <p className="mt-4">
                  Diese Datenschutzerklärung informiert darüber, welche Daten wir erheben, wie wir sie verwenden und welche Rechte Ihnen zustehen.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">3. Erhebung und Speicherung personenbezogener Daten</h3>
                <p className="mb-4">
                  Wir verarbeiten personenbezogene Daten, die Sie uns im Rahmen einer Kontaktaufnahme (z. B. über das Kontaktformular oder per E-Mail) freiwillig mitteilen. Dazu gehören insbesondere:
                </p>
                <ul className="list-disc list-inside space-y-2 mb-4">
                  <li>Name, E-Mail-Adresse, Telefonnummer</li>
                  <li>Unternehmensname</li>
                  <li>Projektanfragen oder Nachrichteninhalte</li>
                </ul>
                <p>
                  Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung oder vorvertragliche Maßnahmen).
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">4. Hosting</h3>
                <p className="mb-4">
                  Unsere Website wird über den Anbieter Emergent.sh gehostet und bereitgestellt.
                </p>
                <p className="mb-4">
                  Emergent.sh ist eine KI-gestützte No-Code-Plattform, die sowohl Frontend als auch Backend der Website generiert, betreibt und verwaltet.
                </p>
                <p className="mb-4">
                  Im Rahmen der Nutzung werden automatisch technische Daten erfasst, die Ihr Browser übermittelt, insbesondere:
                </p>
                <ul className="list-disc list-inside space-y-2 mb-4">
                  <li>IP-Adresse</li>
                  <li>Browsertyp und -version</li>
                  <li>Betriebssystem</li>
                  <li>Referrer-URL</li>
                  <li>Uhrzeit der Serveranfrage</li>
                </ul>
                <p className="mb-4">
                  Diese Daten werden durch Emergent.sh auf Servern in der Europäischen Union oder den USA verarbeitet.
                </p>
                <p className="mb-4">
                  Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer sicheren und funktionsfähigen Website).
                </p>
                <p>
                  Zwischen der Lussho GmbH und Emergent.sh besteht eine Vereinbarung zur Auftragsverarbeitung gemäß Art. 28 DSGVO.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">5. Verwendung von Google Fonts</h3>
                <p className="mb-4">
                  Zur einheitlichen Darstellung von Schriftarten verwenden wir Google Fonts. Beim Aufruf einer Seite lädt Ihr Browser die benötigten Schriftarten in den Cache, um Texte korrekt anzuzeigen.
                </p>
                <p className="mb-4">
                  Hierbei kann eine Verbindung zu Servern von Google in den USA hergestellt werden.
                </p>
                <p className="mb-4">
                  Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO.
                </p>
                <p>
                  Weitere Informationen: <a href="https://policies.google.com/privacy" className="text-[#ff5200] hover:underline" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a>
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">6. Kontaktformular und Kommunikation</h3>
                <p className="mb-4">
                  Wenn Sie uns über das Kontaktformular oder per E-Mail kontaktieren, werden Ihre Angaben zwecks Bearbeitung Ihrer Anfrage gespeichert.
                </p>
                <p className="mb-4">
                  Eine Weitergabe erfolgt nur, wenn dies zur Vertragserfüllung notwendig ist.
                </p>
                <p>
                  Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">7. Nutzung von Tracking- und Analysetools</h3>
                <p className="mb-4">
                  Wir verwenden gängige Tracking- und Analysetools wie Google Analytics, Meta Pixel, TikTok Ads und LinkedIn Insight Tag, um das Nutzerverhalten zu analysieren und unsere Marketingmaßnahmen zu optimieren.
                </p>
                <p className="mb-4">
                  Dabei können Cookies gesetzt und pseudonymisierte Nutzungsprofile erstellt werden.
                </p>
                <p className="mb-4">
                  Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).
                </p>
                <p>
                  Ihre Einwilligung können Sie jederzeit über die Cookie-Einstellungen auf unserer Website widerrufen.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">8. Social Media & eingebettete Inhalte</h3>
                <p className="mb-4">
                  Unsere Website enthält Links und Einbindungen zu Social-Media-Plattformen (z. B. Instagram, LinkedIn, TikTok).
                </p>
                <p className="mb-4">
                  Beim Besuch dieser Seiten gelten die Datenschutzrichtlinien der jeweiligen Anbieter.
                </p>
                <p>
                  Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (Online-Präsenz und Öffentlichkeitsarbeit).
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">8.1. Website-Erstellung und KI-Technologie (Emergent AI / emergent.sh)</h3>
                <p className="mb-4">
                  Diese Website wurde mithilfe von Emergent AI (emergent.sh) entwickelt, einer KI-basierten No-Code-Plattform, die Website-Strukturen, Benutzeroberflächen, Texte und Datenbanken automatisch generiert.
                </p>
                <p className="mb-4">
                  <strong>Datenverarbeitung:</strong> Emergent.sh fungiert im Sinne der DSGVO als Auftragsverarbeiter. Interaktionsdaten (z. B. Seitenaufrufe, Formularübermittlungen) können auf Servern in der EU oder den USA verarbeitet werden. Die Verarbeitung erfolgt ausschließlich zum Zweck der technischen Bereitstellung und Sicherheit.
                </p>
                <p className="mb-4">
                  <strong>KI-generierte Inhalte:</strong> Einige visuelle Elemente, Texte und Layout-Komponenten dieser Website wurden durch künstliche Intelligenz generiert. Alle Inhalte werden vor Veröffentlichung redaktionell geprüft.
                </p>
                <p className="mb-4">
                  <strong>Hosting:</strong> Die gesamte Website wird über Emergent.sh gehostet und betrieben. Dabei werden technische Protokolldaten (z. B. IP-Adresse, Browsertyp, Zugriffszeiten) zur Aufrechterhaltung der Systemsicherheit gespeichert.
                </p>
                <p>
                  Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer modernen, sicheren Website-Infrastruktur).
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">9. Rechte der betroffenen Personen</h3>
                <p className="mb-2">Sie haben jederzeit das Recht auf:</p>
                <ul className="list-disc list-inside space-y-2 mb-4">
                  <li>Auskunft über die gespeicherten Daten (Art. 15 DSGVO)</li>
                  <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
                  <li>Löschung Ihrer Daten (Art. 17 DSGVO)</li>
                  <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                  <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
                  <li>Widerspruch gegen Verarbeitung (Art. 21 DSGVO)</li>
                </ul>
                <p>
                  Beschwerden können Sie an die zuständige Datenschutzbehörde richten.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">10. Änderungen dieser Datenschutzerklärung</h3>
                <p>
                  Wir behalten uns vor, diese Datenschutzerklärung bei technischen oder rechtlichen Änderungen anzupassen.
                </p>
              </div>
            </div>
          ) : (
            <div className="space-y-8">
              <p className="text-sm text-gray-600">Last updated: November 2025</p>
              
              <div>
                <h2 className="text-3xl font-bold mb-4">Privacy Policy</h2>
                <h3 className="text-2xl font-bold mb-3">1. Data Controller</h3>
                <p>
                  Lussho GmbH<br />
                  operating as PIK Agency<br />
                  Sachsenhäuser Landwehrweg 159A<br />
                  60599 Frankfurt am Main, Germany<br />
                  Email: hello@pikagency.de<br />
                  Phone: +49 172 3068227
                </p>
                <p className="mt-4">
                  Managing Directors:<br />
                  Esma Kaya Gürsoy, Yagmur Yüksel
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">2. General Information</h3>
                <p className="mb-4">
                  We take your privacy seriously. Personal data is processed in compliance with the GDPR and relevant data protection laws.
                </p>
                <p>
                  This privacy policy explains what data we collect, how we use it, and your rights.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">3. Data Collection and Use</h3>
                <p className="mb-4">
                  We collect personal data you provide voluntarily (via contact form or email), such as:
                </p>
                <ul className="list-disc list-inside space-y-2 mb-4">
                  <li>Name, email, phone number</li>
                  <li>Company name</li>
                  <li>Message or project inquiry</li>
                </ul>
                <p>
                  Processing is based on Art. 6 (1)(b) GDPR (performance of a contract or pre-contractual measures).
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">4. Hosting</h3>
                <p className="mb-4">
                  Our website is hosted and operated by Emergent.sh, an AI-powered no-code platform responsible for generating and maintaining both the frontend and backend.
                </p>
                <p className="mb-4">
                  During use, technical data automatically transmitted by your browser may be collected, including:
                </p>
                <ul className="list-disc list-inside space-y-2 mb-4">
                  <li>IP address</li>
                  <li>Browser type and version</li>
                  <li>Operating system</li>
                  <li>Referrer URL</li>
                  <li>Time of access</li>
                </ul>
                <p className="mb-4">
                  Emergent.sh processes this data on servers located in the European Union or the United States.
                </p>
                <p className="mb-4">
                  A data processing agreement (DPA) in line with Art. 28 GDPR is in place between Lussho GmbH and Emergent.sh.
                </p>
                <p>
                  Legal basis: Art. 6 (1)(f) GDPR (legitimate interest in secure and reliable website operation).
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">5. Google Fonts</h3>
                <p className="mb-4">
                  We use Google Fonts for consistent typography. Your browser may connect to Google servers (possibly in the USA).
                </p>
                <p className="mb-4">
                  Legal basis: Art. 6 (1)(f) GDPR.
                </p>
                <p>
                  More info: <a href="https://policies.google.com/privacy" className="text-[#ff5200] hover:underline" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a>
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">6. Contact Form and Email</h3>
                <p className="mb-4">
                  If you contact us via form or email, we store your information to process your inquiry.
                </p>
                <p>
                  Legal basis: Art. 6 (1)(b) GDPR.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">7. Analytics and Tracking Tools</h3>
                <p className="mb-4">
                  We use tools such as Google Analytics, Meta Pixel, TikTok Ads, and LinkedIn Insight Tag to analyze user interactions and improve marketing activities.
                </p>
                <p className="mb-4">
                  Cookies and pseudonymous usage profiles may be created.
                </p>
                <p className="mb-4">
                  Legal basis: Art. 6 (1)(a) GDPR (consent).
                </p>
                <p>
                  You can withdraw consent at any time via our cookie preferences.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">8. Social Media & Embedded Content</h3>
                <p className="mb-4">
                  Our site includes links and embedded content from platforms such as Instagram, LinkedIn, and TikTok.
                </p>
                <p className="mb-4">
                  When accessing these, the respective providers privacy policies apply.
                </p>
                <p>
                  Legal basis: Art. 6 (1)(f) GDPR (public relations and brand presence).
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">8.1. Website Development and AI Technology (Emergent AI / emergent.sh)</h3>
                <p className="mb-4">
                  This website was developed and hosted using Emergent AI (emergent.sh), an AI-powered no-code platform that automatically generates the site's code, UI, and database structure.
                </p>
                <p className="mb-4">
                  <strong>Data Processing:</strong> Emergent.sh acts as a data processor under the GDPR. Interaction data (e.g., page views, form submissions) may be processed on servers in the EU or USA, solely for technical performance and security.
                </p>
                <p className="mb-4">
                  <strong>AI-Generated Content:</strong> Some design elements, text, and layout components are AI-generated. All content is human-reviewed before publication.
                </p>
                <p className="mb-4">
                  <strong>Hosting:</strong> The entire site is hosted on Emergent.sh's infrastructure, where technical logs (e.g., IP addresses, access times) are stored to maintain system stability.
                </p>
                <p>
                  Legal basis: Art. 6 (1)(f) GDPR (legitimate interest in secure, modern website operation).
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">9. Your Rights</h3>
                <p className="mb-2">You have the right to:</p>
                <ul className="list-disc list-inside space-y-2 mb-4">
                  <li>Access your stored data (Art. 15 GDPR)</li>
                  <li>Rectify incorrect data (Art. 16 GDPR)</li>
                  <li>Request deletion (Art. 17 GDPR)</li>
                  <li>Restrict processing (Art. 18 GDPR)</li>
                  <li>Data portability (Art. 20 GDPR)</li>
                  <li>Object to processing (Art. 21 GDPR)</li>
                </ul>
                <p>
                  You can contact the relevant data protection authority for complaints.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">10. Changes to this Privacy Policy</h3>
                <p>
                  We may update this policy to reflect changes in technology or legal requirements.
                </p>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Privacy;
